import translatedMessagesRu from './translations/ru'
import translatedMessagesEn from './translations/en'
import translatedMessagesEs from './translations/es'

export default {
  ru: translatedMessagesRu,
  en: translatedMessagesEn,
  es: translatedMessagesEs
}
